import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'al-supporting-links',
    template: `
        <ng-container [ngSwitch]="supportingLinksMode">

            <!-- START : Supporting Links with JSON Data ( Default View ) -->
            <ng-container *ngIf="!apiFlag">
                <div *ngSwitchCase="'supportingLinks'">
                    <h4 class="al-linklist-vertical-header">{{title}}</h4>
                    <ul class="al-linklist-vertical-link">
                        <li *ngFor='let list of lists'>
                            <a href="{{list.link}}">{{list.value}}</a> <span *ngIf="list.infoText">{{list.infoText}}</span>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <ng-container *ngIf="apiFlag">
                <div *ngSwitchCase="'supportingLinks'">
                    <h4 class="al-linklist-vertical-header">{{title}}</h4>
                    <ul class="al-linklist-vertical-link">
                        <li *ngFor='let list of lists'>
                            <span [innerHTML]="list.value.tag | UISafe : 'html'"></span>
                            <span *ngIf="list.value.displayText">{{list.value.displayText}}</span>
                        </li>
                    </ul>
                </div>
            </ng-container>

            <!-- START : Supporting Links with custom content ( user provided content ) -->
            <div *ngSwitchCase="'supportingLinksCustomContent'">
                <h4 class="al-linklist-vertical-header">{{title}}</h4>
                <ul class="al-linklist-vertical-link">
                    <ng-container *ngTemplateOutlet="supportingLinksTemplateRef; context: exampleContext"></ng-container>
                </ul>
            </div>

            <!-- START : Other resources with JSON Data -->
            <ng-container *ngIf="!apiFlag">
                <div class="al-other-resources" *ngSwitchCase="'otherResources'">
                    <h3 class="al-other-resources-title">
                        <span class="al-other-resources-checkbox"><div class="al-other-resources-checkbox-icon"></div></span> {{title}}
                    </h3>
                    <ul class="al-other-resources-list">
                        <li *ngFor='let list of lists' class="al-other-resources-list-item"  [ngClass]="(list.disableLink == true) ? 'al-dead-link' : '' ">
                            <a href="{{list.link}}">{{list.value}}</a>
                        </li>
                    </ul>
                </div>
            </ng-container>

            <ng-container *ngIf="apiFlag">
                <div class="al-other-resources" *ngSwitchCase="'otherResources'">
                    <h3 class="al-other-resources-title">
                        <span class="al-other-resources-checkbox"><div class="al-other-resources-checkbox-icon"></div></span> {{title}}
                    </h3>
                    <ul class="al-other-resources-list">
                        <li *ngFor='let list of lists' class="al-other-resources-list-item">
                            <span [innerHTML]="list.value.tag | UISafe : 'html'"></span>
                        </li>
                    </ul>
                </div>
            </ng-container>

            <!-- START : Other resources with custom content ( user provided content ) -->
            <div class="al-other-resources" *ngSwitchCase="'otherResourcesCustomContent'">
                <h3 class="al-other-resources-title">
                    <span class="al-other-resources-checkbox"><div class="al-other-resources-checkbox-icon"></div></span> {{title}}
                </h3>
                <ul class="al-other-resources-list">
                    <ng-container *ngTemplateOutlet="supportingLinksTemplateRef; context: exampleContext"></ng-container>
                </ul>
            </div>

        </ng-container>

        <ng-template #supportingLinksTemplateRef>
            <ng-content></ng-content>
        </ng-template>
    `
})

export class AlSupportingLinksComponent implements OnInit {

    // set data as lists array type
    @Input() lists: any;

    // set supporting links title, default is Additional Resources
    @Input() title: string = 'Additional Resources';

    // switch between various templates of supportlinks and other resources ( Default value is  : supportingLinks)
    @Input() supportingLinksMode: string = 'supportingLinks';

    apiFlag: boolean = false;

    // Array for API Data
    listsArray = [];

    ngOnInit() {
        this.validateListsData(this.lists);
    }

    /**
     * name
     */
    public exampleContext() {

    }

    // Manipulate data from API Service
    validateListsData(data) {
        if (data) {
            const hasRequiredKey = data[0].hasOwnProperty('link');
            if (hasRequiredKey) {
                Object.keys(data[0].link).forEach(key => {
                    this.listsArray.push({ 'key': key, 'value': data[0].link[key] });
                });
                if (this.listsArray[0].value.hasOwnProperty('tag')) {
                    this.apiFlag = true;
                    this.lists = this.listsArray;
                }
            }
        }
    }

}
